import Delta from 'quill-delta';

const defaults = {
  globalRegularExpression: /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g,
  emailRegularExpression: /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/
};

export default class MagicEmail {
  constructor(quill, options = {}) {
    this.quill = quill;
    this.options = { ...defaults, ...options };
    this.registerTypeListener();
    this.registerPasteListener();
  }

  registerPasteListener() {
    // eslint-disable-next-line no-undef
    this.quill.clipboard.addMatcher(Node.TEXT_NODE, (node, delta) => {
      if (typeof node.data !== 'string') {
        return;
      }
      const matches = node.data.match(this.options.globalRegularExpression);
      if (matches && matches.length > 0) {
        const newDelta = new Delta();
        let str = node.data;
        matches.forEach(match => {
          const split = str.split(match);
          const beforeLink = split.shift();
          newDelta.insert(beforeLink);
          newDelta.insert(match, { link: `mailto:${match}` });
          str = split.join(match);
        });
        newDelta.insert(str);
        // eslint-disable-next-line no-param-reassign
        delta.ops = newDelta.ops;
      }
      return delta;
    });
  }

  registerTypeListener() {
    this.quill.on('text-change', delta => {
      const { ops } = delta;
      if (!ops || ops.length < 1 || ops.length > 2) {
        return;
      }
      const lastOp = ops[ops.length - 1];
      if (!lastOp.insert || typeof lastOp.insert !== 'string' || !lastOp.insert.match(/\s/)) {
        return;
      }
      this.checkTextForUrl();
    });
  }

  checkTextForUrl() {
    const sel = this.quill.getSelection();
    if (!sel) {
      return;
    }
    const [leaf] = this.quill.getLeaf(sel.index);
    if (!leaf.text || leaf.parent.domNode.localName === 'a') {
      return;
    }
    const emailMatch = leaf.text.match(this.options.emailRegularExpression);
    if (!emailMatch) {
      return;
    }
    const leafIndex = this.quill.getIndex(leaf);
    const index = leafIndex + emailMatch.index;

    this.emailToUrl(index, emailMatch[0]);
  }

  emailToUrl(index, email) {
    const ops = new Delta()
      .retain(index)
      .delete(email.length)
      .insert(email, { link: `mailto:${email}` });
    this.quill.updateContents(ops);
  }
}
